import { render } from "./LoginButton.vue?vue&type=template&id=fba89dc0&scoped=true&ts=true"
import script from "./LoginButton.vue?vue&type=script&lang=ts"
export * from "./LoginButton.vue?vue&type=script&lang=ts"

import "./LoginButton.vue?vue&type=style&index=0&id=fba89dc0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fba89dc0"]])

export default __exports__